import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="privacy-policy">
      <div class="container">
        <h1>Privacy Policy</h1>
        <div class="content">
          <div class="last-updated">
            Last Updated: {{ lastUpdated | date:'longDate' }}
          </div>

          <div class="policy-section">
            <h2>1. Introduction</h2>
            <p>
              This Privacy Policy describes how Industry Intelligence ("we," "our," or "us") 
              collects, uses, and shares your personal information when you use our services.
            </p>
          </div>

          <div class="policy-section">
            <h2>2. Information We Collect</h2>
            <h3>2.1 Information You Provide</h3>
            <ul>
              <li>Account information (name, email, company)</li>
              <li>Profile information</li>
              <li>Communication preferences</li>
            </ul>

            <h3>2.2 Automatically Collected Information</h3>
            <ul>
              <li>Device information</li>
              <li>Usage data</li>
              <li>Cookies and similar technologies</li>
            </ul>
          </div>

          <div class="policy-section">
            <h2>3. How We Use Your Information</h2>
            <p>We use the collected information to:</p>
            <ul>
              <li>Provide and improve our services</li>
              <li>Personalize your experience</li>
              <li>Send important updates and communications</li>
              <li>Ensure security and prevent fraud</li>
            </ul>
          </div>

          <!-- Add more sections as needed -->
        </div>
      </div>
    </section>
  `,
  styles: [`
    .privacy-policy {
      padding: 3rem 0;
    }

    .container {
      max-width: 900px;
      margin: 0 auto;
      padding: 0 1rem;
    }

    h1 {
      font-size: 2.5rem;
      margin-bottom: 2rem;
      color: var(--primary-color);
    }

    .content {
      background: white;
      padding: 2rem;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .last-updated {
      color: var(--text-secondary);
      font-style: italic;
      margin-bottom: 2rem;
    }

    .policy-section {
      margin-bottom: 2rem;
    }

    h2 {
      font-size: 1.5rem;
      margin-bottom: 1rem;
      color: var(--text-primary);
    }

    h3 {
      font-size: 1.2rem;
      margin: 1rem 0;
      color: var(--text-primary);
    }

    p {
      margin-bottom: 1rem;
      line-height: 1.6;
    }

    ul {
      margin-left: 1.5rem;
      margin-bottom: 1rem;
    }

    li {
      margin-bottom: 0.5rem;
      line-height: 1.6;
    }
  `]
})
export class PrivacyPolicyComponent {
  lastUpdated = new Date('2024-02-24');
} 